import { fetcher, getCsrfToken } from "../fetcher";

export const authService = {
  login: async (payload: LoginForm) => {
    return await fetcher(`/login`, {
      method: "POST",
      body: payload,
    });
  },
  logout: async () => {
    return await fetcher(`/logout`, {
      method: "POST",
    });
  },
  remindPasswordEmail: async (payload: RemindPasswordEmailProps) => {
    return await fetcher(`/forgot-password`, {
      method: "POST",
      body: payload,
    });
  },
  resetPassword: async (payload: ResetPasswordForm) => {
    return await fetcher(`/reset-password`, {
      method: "POST",
      body: payload,
    });
  },
  changePassword: async (payload: ChangePassword) => {
    return await fetcher(`/change-password`, {
      method: "POST",
      body: payload,
    });
  },
  confirmNewEmail: async (payload: ConfirmNewEmail) => {
    return await fetcher(`/confirm-new-email`, {
      method: "POST",
      body: payload,
    });
  },
  getCsrf: () => {
    return getCsrfToken();
  },
  getAccount: async () => {
    return await fetcher(`/me`, {
      method: "GET",
      schema: userSchema,
    });
  },
  adminLogin: async (payload: LoginForm & { userId: string | string[] }) => {
    return await fetcher(`/admin/login/${payload.userId}`, {
      method: "POST",
    });
  },
};
